import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';

@JsonObject('model.project.Project')
export class TicketStatus extends AbstractModel {

	@JsonProperty(String, 'name')
	name?: string;

	@JsonProperty(String, 'colour')
	colour?: string;

	@JsonProperty(String, 'treat-as-closed')
	treatAsClosed?: boolean;
}
